export default class ListNode {
    constructor(data) {
        this.data = data;
        this.next = null;
        this.previous = null;
    };
}